/**
 * Tailwind-variants definition for `<GeneralIconV4>`. Lives in a sibling
 * file (not in `GeneralIcons.v4.tsx`) so the component file only exports
 * components — required by `react-refresh/only-export-components` for HMR
 * to work without forcing a full reload on style edits.
 */
import { tv, type VariantProps } from 'tailwind-variants';

export const generalIconV4Variants = tv({
  base: 'inline-block',
});

export type GeneralIconV4VariantProps = VariantProps<typeof generalIconV4Variants>;
